import { Component } from "react";
import * as React from "react";
import { Link, NavLink } from "react-router-dom";
import { Location } from "history";

class Menu extends Component<any, any> {

	public render() {
		return (
			<div className="bg-white">
				<div className="content">
					{/* Mobilní menu */}
					<div className="d-lg-none push">
						<button type="button"
								className="btn btn-block btn-light d-flex justify-content-between align-items-center"
								data-toggle="class-toggle" data-target="#main-navigation" data-class="d-none">
							Hlavní menu
						</button>
					</div>

					{/* Normální menu */}
					<div id="main-navigation" className="d-none d-lg-block push">
						<ul className="nav-main nav-main-horizontal nav-main-hover">
							<li className="nav-main-item">
								<NavLink className="nav-main-link" exact={true} to="/">
									<span className="nav-main-link-name">Domů</span>
								</NavLink>
							</li>
							<li className="nav-main-item">
								<NavLink className="nav-main-link" to="/leaderboard/server/survival"
									isActive={(_match: any, location: Location) => {
										return location.pathname.includes("/leaderboard/server/");
									}}>
									<span className="nav-main-link-name">Server leaderboardy</span>
								</NavLink>
								<ul className="nav-main-submenu">
									<li className="nav-main-item">
										<Link className="nav-main-link" to="/leaderboard/server/global">
											<span className="nav-main-link-name">Global</span>
										</Link>
									</li>
									<li className="nav-main-item">
										<span className="nav-main-link nav-main-link-submenu" data-toggle="submenu"
											aria-haspopup="true" aria-expanded="false">
											<span className="nav-main-link-name">Survival [1.17]</span>
										</span>
										<ul className="nav-main-submenu">
											<li className="nav-main-item">
												<Link className="nav-main-link" to="/leaderboard/server/survival">
													<span className="nav-main-link-name">Leaderboard</span>
												</Link>
											</li>
											<li className="nav-main-item">
												<Link className="nav-main-link" to="/leaderboard/survival/balance">
													<span className="nav-main-link-name">Nejbohatší hráči</span>
												</Link>
											</li>
										</ul>
									</li>
									<li className="nav-main-item">
										<span className="nav-main-link nav-main-link-submenu" data-toggle="submenu"
											aria-haspopup="true" aria-expanded="false">
											<span className="nav-main-link-name">Skyblock</span>
										</span>
										<ul className="nav-main-submenu">
											<li className="nav-main-item">
												<Link className="nav-main-link" to="/leaderboard/server/skyblock">
													<span className="nav-main-link-name">Leaderboard</span>
												</Link>
											</li>
											<li className="nav-main-item">
												<Link className="nav-main-link" to="/leaderboard/skyblock/balance">
													<span className="nav-main-link-name">Nejbohatší hráči</span>
												</Link>
											</li>
											{/*<li className="nav-main-item">
                                                <Link className="nav-main-link" to="/leaderboard/skyblock/islands">
                                                    <span className="nav-main-link-name">Island top</span>
                                                </Link>
                                            </li>*/}
										</ul>
									</li>
									<li className="nav-main-item">
										<Link className="nav-main-link" to="/leaderboard/server/creative">
											<span className="nav-main-link-name">Creative</span>
										</Link>
									</li>
									<li className="nav-main-item">
										<span className="nav-main-link nav-main-link-submenu" data-toggle="submenu"
											aria-haspopup="true" aria-expanded="false">
											<span className="nav-main-link-name">Vanilla: Lands</span>
										</span>
										<ul className="nav-main-submenu">
											<li className="nav-main-item">
												<Link className="nav-main-link" to="/leaderboard/server/vanilla">
													<span className="nav-main-link-name">Leaderboard</span>
												</Link>
											</li>
											<li className="nav-main-item">
												<Link className="nav-main-link" to="/leaderboard/vanilla/dragon-slayer">
													<span className="nav-main-link-name">Dragon Slayers</span>
												</Link>
											</li>
										</ul>
									</li>
									<li className="nav-main-item">
										<span className="nav-main-link nav-main-link-submenu" data-toggle="submenu"
											aria-haspopup="true" aria-expanded="false">
											<span className="nav-main-link-name">Staré servery</span>
										</span>
										<ul className="nav-main-submenu">
											<li className="nav-main-item">
												<Link className="nav-main-link" to="/leaderboard/server/old/skycloud">
													<span className="nav-main-link-name">SkyCloud 1.15 (2020)</span>
												</Link>
											</li>
											<li className="nav-main-item">
												<Link className="nav-main-link" to="/leaderboard/server/old/hardcore-vanilla">
													<span className="nav-main-link-name">Hardcore Vanilla 1.16 (2021)</span>
												</Link>
											</li>
											<li className="nav-main-item">
												<Link className="nav-main-link" to="/leaderboard/server/old/vanilla_116">
													<span className="nav-main-link-name">Vanilla 1.16 (2021)</span>
												</Link>
											</li>
											<li className="nav-main-item">
												<Link className="nav-main-link" to="/leaderboard/server/old/prison_116">
													<span className="nav-main-link-name">Prison 1.16 (2021)</span>
												</Link>
											</li>
										</ul>
									</li>
								</ul>
							</li>
							<li className="nav-main-item">
								<NavLink className="nav-main-link" to="/leaderboard/economy/craft-coins"
									isActive={(_match: any, location: Location) => {
										return location.pathname.includes("/leaderboard/economy/");
									}}>
									<span className="nav-main-link-name">Economy leaderboardy</span>
								</NavLink>
								<ul className="nav-main-submenu">
									<li className="nav-main-item">
										<Link className="nav-main-link" to="/leaderboard/economy/craft-coins">
											<span className="nav-main-link-name">CraftCoins</span>
										</Link>
									</li>
									<li className="nav-main-item">
										<Link className="nav-main-link" to="/leaderboard/economy/craft-tokens">
											<span className="nav-main-link-name">CraftTokens</span>
										</Link>
									</li>
									<li className="nav-main-item">
										<Link className="nav-main-link" to="/leaderboard/economy/vote-tokens">
											<span className="nav-main-link-name">VoteTokens</span>
										</Link>
									</li>
									<li className="nav-main-item">
										<Link className="nav-main-link" to="/leaderboard/economy/played-time">
											<span className="nav-main-link-name">Odehraný čas</span>
										</Link>
									</li>
									<li className="nav-main-item">
										<Link className="nav-main-link" to="/leaderboard/economy/quest-points">
											<span className="nav-main-link-name">Quest Points</span>
										</Link>
									</li>
									<li className="nav-main-item">
										<Link className="nav-main-link" to="/leaderboard/economy/event-points">
											<span className="nav-main-link-name">Event Points</span>
										</Link>
									</li>
									<li className="nav-main-item">
										<Link className="nav-main-link" to="/leaderboard/economy/season-points">
											<span className="nav-main-link-name">Season Points</span>
										</Link>
									</li>
								</ul>
							</li>
							<li className="nav-main-item">
								<NavLink className="nav-main-link" to="/leaderboard/votes/total"
									isActive={(_match: any, location: Location) => {
										return location.pathname.includes("/leaderboard/votes/");
									}}>
									<span className="nav-main-link-name">Vote leaderboardy</span>
								</NavLink>
								<ul className="nav-main-submenu">
									<li className="nav-main-item">
										<Link className="nav-main-link" to="/leaderboard/votes/total">
											<span className="nav-main-link-name">Nejvíce hlasů celkem</span>
										</Link>
									</li>
									<li className="nav-main-item">
										<Link className="nav-main-link" to="/leaderboard/votes/month">
											<span className="nav-main-link-name">Nejvíce hlasů tento měsíc</span>
										</Link>
									</li>
									<li className="nav-main-item">
										<Link className="nav-main-link" to="/leaderboard/votes/week">
											<span className="nav-main-link-name">Nejvíce hlasů tento týden</span>
										</Link>
									</li>
								</ul>
							</li>
							<li className="nav-main-item">
								<NavLink className="nav-main-link" to="/leaderboard/mcmmo/drevorubectvi"
									isActive={(_match: any, location: Location) => {
										return location.pathname.includes("/leaderboard/mcmmo/");
									}}>
									<span className="nav-main-link-name">McMMO leaderboardy</span>
								</NavLink>
								<ul className="nav-main-submenu">
									<li className="nav-main-item">
										<span className="nav-main-link nav-main-link-submenu" data-toggle="submenu"
											aria-haspopup="true" aria-expanded="false">
											<span className="nav-main-link-name">Survival [1.17]</span>
										</span>
										<ul className="nav-main-submenu">
											<li className="nav-main-item">
												<Link className="nav-main-link" to="/leaderboard/mcmmo/survival/woodcutting">
													<span className="nav-main-link-name">Dřevorubectví</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/survival/swords">
													<span className="nav-main-link-name">Meče</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/survival/taming">
													<span className="nav-main-link-name">Ochočování</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/survival/mining">
													<span className="nav-main-link-name">Dolování</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/survival/excavation">
													<span className="nav-main-link-name">Kopání</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/survival/repair">
													<span className="nav-main-link-name">Opravování</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/survival/unarmed">
													<span className="nav-main-link-name">Neozbrojený boj</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/survival/herbalism">
													<span className="nav-main-link-name">Bylinkářství</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/survival/archery">
													<span className="nav-main-link-name">Lukostřelba</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/survival/axes">
													<span className="nav-main-link-name">Sekery</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/survival/acrobatics">
													<span className="nav-main-link-name">Akrobacie</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/survival/fishing">
													<span className="nav-main-link-name">Rybaření</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/survival/alchemy">
													<span className="nav-main-link-name">Alchemie</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/survival/total">
													<span className="nav-main-link-name">Celkový levels</span>
												</Link>
											</li>
										</ul>
									</li>
									<li className="nav-main-item">
										<span className="nav-main-link nav-main-link-submenu" data-toggle="submenu"
											aria-haspopup="true" aria-expanded="false">
											<span className="nav-main-link-name">Skyblock [1.17]</span>
										</span>
										<ul className="nav-main-submenu">
											<li className="nav-main-item">
												<Link className="nav-main-link" to="/leaderboard/mcmmo/skyblock/woodcutting">
													<span className="nav-main-link-name">Dřevorubectví</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/skyblock/swords">
													<span className="nav-main-link-name">Meče</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/skyblock/taming">
													<span className="nav-main-link-name">Ochočování</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/skyblock/mining">
													<span className="nav-main-link-name">Dolování</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/skyblock/excavation">
													<span className="nav-main-link-name">Kopání</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/skyblock/repair">
													<span className="nav-main-link-name">Opravování</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/skyblock/unarmed">
													<span className="nav-main-link-name">Neozbrojený boj</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/skyblock/herbalism">
													<span className="nav-main-link-name">Bylinkářství</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/skyblock/archery">
													<span className="nav-main-link-name">Lukostřelba</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/skyblock/axes">
													<span className="nav-main-link-name">Sekery</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/skyblock/acrobatics">
													<span className="nav-main-link-name">Akrobacie</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/skyblock/fishing">
													<span className="nav-main-link-name">Rybaření</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/skyblock/alchemy">
													<span className="nav-main-link-name">Alchemie</span>
												</Link>
												<Link className="nav-main-link" to="/leaderboard/mcmmo/skyblock/total">
													<span className="nav-main-link-name">Celkový levels</span>
												</Link>
											</li>
										</ul>
									</li>
								</ul>
							</li>
							<li className="nav-main-item">
								<NavLink className="nav-main-link" to="/minigames/halloween"
									isActive={(_match: any, location: Location) => {
										return location.pathname.includes("/minigames/");
									}}>
									<span className="nav-main-link-name">MiniGames Leaderboardy</span>
								</NavLink>
								<ul className="nav-main-submenu">
									<li className="nav-main-item">
										<Link className="nav-main-link" to="/minigames/halloween">
											<span className="nav-main-link-name">Dead By Daylight</span>
										</Link>
									</li>
								</ul>
							</li>
							<li className="nav-main-item">
								<NavLink className="nav-main-link" exact={true} to="/leaderboard/reputation">
									<span className="nav-main-link-name">Reputace</span>
								</NavLink>
							</li>
						</ul>
					</div>
				</div>
			</div>
		);
	}
}

export default Menu;
